import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import SaferHomesSmarterDecisions from "./sections/SaferHomesSmarterDecisions";
import OurTrustCommitment from "./sections/OurTrustCommitment";
import ExploreSafetyCategories from "./sections/ExploreSafetyCategories";
import FindYourPerfectSystem from "./sections/FindYourPerfectSystem";
import TopSecurityPicks2026 from "./sections/TopSecurityPicks2026";
import ExpertBuyingGuides from "./sections/ExpertBuyingGuides";
import WhyFamiliesTrustSafebode from "./sections/WhyFamiliesTrustSafebode";
import CommonSafetyQuestions from "./sections/CommonSafetyQuestions";
import StayProtected from "./sections/StayProtected";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <SaferHomesSmarterDecisions />
      <OurTrustCommitment />
      <ExploreSafetyCategories />
      <FindYourPerfectSystem />
      <TopSecurityPicks2026 />
      <ExpertBuyingGuides />
      <WhyFamiliesTrustSafebode />
      <CommonSafetyQuestions />
      <StayProtected />
      <Footer />
    </div>;
}